module.exports = __webpack_public_path__ + "static/media/Ds1v6.ff3906ab.mp3";